import { useClearRefinements } from 'react-instantsearch';

import { INSTANT_SEARCH_TOPIC_FILTER } from '#src/app/pages/search/shared/consts';

type Result = ModelHookResult<
	{
		hideButton: boolean;
	},
	{
		clearRefine: () => void;
	}
>;

export function useClearTopicsFilter(): Result {
	const { refine: clearRefine, canRefine } = useClearRefinements({
		includedAttributes: [INSTANT_SEARCH_TOPIC_FILTER],
	});

	return {
		data: {
			hideButton: !canRefine,
		},
		actions: {
			clearRefine,
		},
	};
}
